import * as z from "zod"
import { DBFeatureName } from ".prisma/client"

// Helper schema for JSON fields
type Literal = boolean | number | string
type Json = Literal | { [key: string]: Json } | Json[]
const literalSchema = z.union([z.string(), z.number(), z.boolean()])
const jsonSchema: z.ZodSchema<Json> = z.lazy(() => z.union([literalSchema, z.array(jsonSchema), z.record(jsonSchema)]))

export const DBFeatureConfigModel = z.object({
  id: z.string(),
  feature: z.nativeEnum(DBFeatureName),
  config: jsonSchema,
  createdAt: z.date(),
  updatedAt: z.date(),
})
